<template>
    <v-container fluid>
      <v-card>

        <v-card-title>Booking Search</v-card-title>
        <v-card-text>
          <v-row >
            <v-col>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search text (names, email, notes)"
              single-line
              hide-details
              v-on:input="debounceInput"
              clearable
              @click:clear="fetchBookings()"          
            ></v-text-field>
            </v-col>
          </v-row>
        
          <v-row>
            <v-col class="d-flex align-center"  v-if="true">
              <v-select
              v-model="filter.stallholder_type"
              :items="stallholderTypes"
              label="Stallholder Type"
              item-text="label"
              item-value="name"
              ></v-select>
            </v-col>
          </v-row>

          <v-row >
            <v-col>
              <v-switch v-model="filter.groupby" value="email" label="Group bookings by email" class="" @change="items = []"></v-switch>
            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table
          :headers="tableHeaders"
          :items="tableData"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="isLoading"
          :must-sort=true
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :footer-props = "{
            'items-per-page-options': [15, 50, 100]
          }"
        >
          <!-- Market Date -->
          <template v-slot:item.market_date="{ item }">
            {{ formatDate(item.market_date) }}
          </template>

          <!-- Stallholder Name -->
          <template v-slot:item.stallholder="{ item }">
            <button class="text-left" text @click="$router.push('stallholders/'+item.stallholder_id)" v-if="(item.booking_id && item.stallholder && item.stallholder_id) || (item.stallholder && item.stallholder_id)" v-html="item.stallholder"></button>
            <span v-else-if="item.stallholder" v-html="item.stallholder"></span>

            <v-tooltip v-if="item.stallholder_admin_note" bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" v-if="item.stallholder_id" :to="`/stallholders/${item.stallholder_id}`" class="mx-2" fab dark x-small depressed color="error">
                  <v-icon dark>mdi-account-alert</v-icon>
                </v-btn>
              </template>
              <span>{{item.stallholder_admin_note}}</span>
            </v-tooltip>
          </template>

          <!-- Stallholder Type -->
          <template v-slot:item.stallholder_type="{ item }">
            <stallholder-type-icon :type="item.stallholder_type"></stallholder-type-icon>
          </template>

          <!-- Email -->
          <template v-slot:item.email="{ item }">
            <mailto-btn :email="item.email"></mailto-btn>
            {{item.email}}
          </template>

          <!-- Paid status -->
          <template v-slot:item.is_paid="{ item }">
            <paid-status :item="item"></paid-status>
          </template>

          <!-- Cancelled Status -->
          <template v-slot:item.is_cancelled="{ item }">
            <cancelled-status :item="item"></cancelled-status>
          </template>

            <template v-slot:item.status_info="{ item }">
            <v-tooltip v-for="(icon, i) in item.status_icons" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click="handleFunctionCall(icon.action, icon.params)" v-on="on" :color="icon.color? icon.color : '' " class="mx-1">{{icon.icon}}</v-icon>
              </template>
              <span>{{icon.tooltip}}</span>
            </v-tooltip>
          </template>

          <!-- Deleted Date -->
          <template v-slot:item.deleted_date="{ item }">
            {{ formatDate(item.deleted_date) }}
          </template>

          <!-- Actions -->
          <template v-slot:item.actions="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(action, i) in tableActions"
                  :key="i"
                  @click="handleDynamicFunctionCall(action, item)"
                >
                  <v-list-item-title>{{ action.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

        </v-data-table>
   
      </v-card>

    <BookingModal
      :dialogVisible="isBookingDialogVisible"
      :selectedItem="selectedBooking"
      @close="dialogClose"
      @update="updateBooking"
      :key="selectedBooking.id ? selectedBooking.id : 0"
    />

    </v-container>

    <!-- <StallholderDialog
      :dialogVisible="isStallholderDialogVisible"
      :selectedStallholder="selectedStallholder ? selectedStallholder : false"
      @close="closeStallholderDialog"
    />

      <v-dialog
        v-model="savingDialog"
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text class="pt-5">
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog> -->
</template>



<script>

import axios from 'axios';
import { mapGetters } from 'vuex'
import BookingModal from '../components/BookingModal';
import StallholderDialog from '../components/StallholderDialog';
import PaidStatus from '../components/PaidStatus';
import CancelledStatus from '../components/CancelledStatus';
import StallholderTypeIcon from '../components/StallholderTypeIcon';
import MailtoBtn from '../components/MailtoBtn';
import { formatDate } from '../js/helpers'
import _ from 'lodash'

export default {
  data() {
    return {
      search: '',
      datemenu: false,
      isStallholderDialogVisible: false,
      savingDialog: false,
      selectedStallholderId: false,
      isBookingDialogVisible: false,
      selectedBookingId: false,
      isLoading: true,
      items: [],
      totalItems: 0,
      options: {
        itemsPerPage: 15,
        page: 1
      },
      sortBy: "market_date",
      sortDesc: true,
      search: '',
      headers: [
        { text: 'ID', value: 'id' },
        {
          text: 'Market Date',
          align: 'right',
          value: 'market_date',
          sortable: true
        },
        { text: 'Stall', align: 'left', value: 'stall_code', sortable: false, width: '80px' }, //todo: fix sortable
        { text: 'Type', value: 'stallholder_type' , sortable: true, width: '80px' },
        // { text: 'Stallholder Business Name (at time of booking)', value: 'stallholder_stall_name', sortable: false }, //todo: fix sortable
        { text: 'Stallholder Names (at time of booking)',  align: 'left', value: 'stallholder', sortable: false }, //todo: fix sortable
        { text: 'Email', align: 'left', value: 'email' }, //todo: fix sortable
        // { text: 'Stallholder Category', value: 'stallholder_category', sortable: false }, //todo: fix sortable
        { text: 'Cancelled', value: 'is_cancelled', sortable: true, align: 'center', width: '120px'},
        { text: 'Paid', value: 'is_paid',  sortable: true, align: 'center', width: '120px' },
        { text: '', value: 'status_info', sortable: false, align: 'right'},
        { text: 'Deleted Date', value: 'deleted_date', sortable: true, align: 'center'},
        { text: 'Booking count', value: 'groupby_count', sortable: true, align: 'center'},
        { text: '', value: 'actions', sortable: false, align: 'right',  width: '50px'}
      ],
      actions: [
        { title: 'Booking Details', function: 'openEditBookingDialog', params: ['id'] },
        { title: 'View All Bookings with this Email', function: 'filterByEmail', params: ['email'] },
      ],
      filter: {
        stallholder_type: '',
        groupby: '',
      },
      stallholderTypes: [
        {'label': 'All', 'name': ''}
      ]
    }
  },
  components: {
    BookingModal,
    StallholderDialog,
    PaidStatus,
    CancelledStatus,
    StallholderTypeIcon,
    MailtoBtn
  },
  watch: {
    options: {
      handler() {
        this.fetchBookings();
      },
      deep: true
    },
    filter: {
      handler() {
        if(!this.filter.groupby && this.sortBy =='groupby_count') // if we're changing back to regular list and it was currently sorted by 'count', don't trigger fetchBookings because
          this.sortBy = 'market_date' // we are changing the sortBy which will trigger it 
        else if(this.filter.groupby =='email' && (this.sortBy !='email' && this.sortBy !='groupby_count'))
          this.sortBy = 'groupby_count'; //default, //this change will trigger fetchbookings
        else
          this.fetchBookings();
      },
      deep: true
    }
  },
  methods: {
    openStallholderDialog (id) { 
      this.isStallholderDialogVisible = true
      this.selectedStallholderId = id;
    },
  
    closeStallholderDialog () { 
      this.isStallholderDialogVisible = false;

      // wait half a sec, before resetting data (otherwise we see the stall name cleared in the booking dialog before the dialog fully transitions)
      setTimeout(() => {
       this.selectedStallholderId = false;
      }, 500)  
    },

    debounceInput: _.debounce(function (e) {
      this.fetchBookings();
    }, 500),

    fetchBookings() {
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        let order = (sortDesc.length === 1 && sortDesc[0] == true) ? 'desc' : 'asc'

        let query = `/wisdom-markets/v1/bookings/?`+
          `page=${page}` +
          `&orderby=${sortBy}`+
          `&order=${order}` +
          `&per_page=${itemsPerPage}`;
    

        if(this.search) {
          let search = encodeURIComponent(this.search.trim().toLowerCase());
          if(search)
            query +=  `&s=${search}`;
        }

        Object.keys(this.filter).forEach(prop => {
          if(this.filter[prop] && this.filter[prop] != '')
            query += `&${prop}=${this.filter[prop]}`;
        });

        this.isLoading = true;

        axios.get(query, {
          headers: {
            'Authorization': `Bearer ${this.$store.state.accessToken}`,
          },
        })
        .then( (response) => {
          let items = response.data;
          const totalItems = parseInt(response.headers['x-wp-total']);
          console.warn({totalItems})

          this.items = items;
          this.totalItems = totalItems;
          this.isLoading = false;

          resolve();

        })
        .catch((error) => {
          // console.log(error);
          // console.log("why the!!!!!");
          // this.isLoading = false;
        })
      });
    },
    handleFunctionCall(action, params) {
      this[action](...params)
    },
    handleDynamicFunctionCall(action, item) {
      let params = action.params.map(param => {
          return item[param];
      })
      this[action.function](...params)
    },
    openEditBookingDialog (id) { 
      this.isBookingDialogVisible = true
      this.selectedBookingId = id;
    },
    dialogClose () { 
      this.isBookingDialogVisible = false;

      // wait half a sec, before resetting data (otherwise we see the stall name cleared in the booking dialog before the dialog fully transitions)
      setTimeout(() => {
      //  this.selectedStallId = false;
       this.selectedBookingId = false;
      }, 500)  
    },
    updateBooking(payload){
      console.group("update booking in bookings results");

      let index = this.items.findIndex(item => item.id===payload.id);

      if (index !== -1)  {
        this.items.splice(index, 1, payload); 
      }else{
        console.log("couldn't find index") // should not happen
      }
      console.groupEnd()
    },
    formatDate(date){
      return formatDate(date);
    },
    filterByEmail(email){ //technically this is just doing a regular 's' search so could pick up bookings where the email exists in an admin note
      this.items = [];
      this.search = email; // the rest api does work with the 'email' parameter, but at this stage I didn't want to add an additional email text field

      if(this.filter.groupby=='email')
         this.filter.groupby=''; // this will trigger fetchbookings, we dont want it triggered twice
      else
        this.fetchBookings();
    }
  },
  computed: {
    ...mapGetters([
      // 'getStallholderById',
      'getStallholderTypes',
      'getStallName'
    ]),
    // selectedStallholder() {
    //   return this.getStallholderById(this.selectedStallholderId)
    // },
    tableHeaders() {

      return this.headers.filter(item => {

        if(this.filter.groupby=='email' && (item.value!='email' && item.value !='groupby_count' && item.value !='actions' ))
          return false

        if(!this.filter.groupby && item.value=='groupby_count')
          return false

        return true
      })
    },
    tableData(){

      return this.items.map( (item, k) => {

         if(this.filter.groupby =='email'){
           item.id = k; // just to prevent vutify js duplicate key warning
         }else{

          item.stall_code = this.getStallName(item.stall_id);
          item.stallholder = `${item.stallholder_stall_name} <br />(${item.first_name} ${item.last_name})`;

          if(!item.stallholder_type)
            item.stallholder_type='casual'; 

          item.status_icons = [];
          if(item.admin_note){
            item.status_icons.push({
              icon: 'mdi-message-text-outline',
              action: 'openEditBookingDialog',
              params: [item.id],
              tooltip: 'Booking Admin Note',
              color: 'red lighten-2'
            });
          }
        }

        return item;
        
      })
    },
    tableActions() {
      return this.actions.filter(item => {
        if(this.filter.groupby=='email' && item.function=='openEditBookingDialog')
          return false

        return true
      })
    },
    selectedBooking() {
      if (!this.selectedBookingId) return false;
      return this.items.find( booking => this.selectedBookingId == booking.id)
    },
  },
  mounted(){

    this.$store.dispatch('getStallholderCategories', { });

    if(!this.$store.state.have_stalls)
      this.$store.dispatch('fetchStallData', { });

    this.stallholderTypes.push(...this.getStallholderTypes);

    //this.$store.dispatch('getStallholders', { });

  }
}
</script>

<style>

</style>